import { render, staticRenderFns } from "./AppEngGrammarAssessment.vue?vue&type=template&id=445babfb&scoped=true"
import script from "./AppEngGrammarAssessment.vue?vue&type=script&lang=js"
export * from "./AppEngGrammarAssessment.vue?vue&type=script&lang=js"
import style0 from "./AppEngGrammarAssessment.vue?vue&type=style&index=0&id=445babfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445babfb",
  null
  
)

export default component.exports